module.exports = __webpack_public_path__ + "pc/img/main-work-img-04.fe6eb437.png";